export default __webpack_public_path__ + "static/media/HeroImage.3b3c2f7b.jpg";